import { useFirebaseStorageUrl } from "@/context/FirebaseStorageUrlContext";
import { Box, Typography, Dialog, DialogContent } from "@mui/material";
import { TaskerMessage } from "@t3/shared";
import { GradientRewardBox, RewardText } from "./GradientRewardBox";

export const ReviewConfirmationDialog = ({
  currentMessage,
}: {
  currentMessage: TaskerMessage;
}) => {
  const { url: mediaFileUrl } = useFirebaseStorageUrl(
    currentMessage?.mediaFiles?.[0]?.url,
  );

  return (
    <Dialog
      open={true}
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: 2,
          overflow: "hidden",
          maxWidth: 600,
          width: "100%",
        },
      }}
    >
      <DialogContent sx={{ p: 0 }}>
        <Box>
          {mediaFileUrl && (
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                overflow: "hidden",
                bgcolor: "grey.100",
              }}
            >
              <Box
                component="img"
                src={mediaFileUrl}
                alt="Message media"
                sx={{
                  height: "100%",
                  maxHeight: "40vh",
                  width: "auto",
                  maxWidth: "100%",
                  objectFit: "contain",
                }}
              />
            </Box>
          )}

          {currentMessage?.rewardOptions &&
            currentMessage?.rewardOptions?.length > 0 && (
              <Box sx={{ p: 3 }}>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 700,
                    mb: 2,
                    textAlign: "center",
                  }}
                >
                  Rewards
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 1.5,
                    mb: 2,
                  }}
                >
                  {currentMessage?.rewardOptions?.map((option, index) => (
                    <GradientRewardBox
                      key={index}
                      programColor="rgba(76, 175, 80, 0.3)"
                      enableHover={false}
                      sx={{ borderRadius: 1 }}
                    >
                      <Box sx={{ p: 2 }}>
                        <RewardText
                          title={option.label}
                          description={option.description}
                          amount={option.amount}
                        />
                      </Box>
                    </GradientRewardBox>
                  ))}
                </Box>
              </Box>
            )}

          {currentMessage?.rejectOptions &&
            currentMessage?.rejectOptions?.length > 0 && (
              <Box sx={{ p: 3 }}>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 700,
                    mb: 2,
                    textAlign: "center",
                    color: "error.main",
                  }}
                >
                  Rejected
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 1.5,
                    mb: 2,
                  }}
                >
                  {currentMessage?.rejectOptions?.map((reason, index) => (
                    <GradientRewardBox
                      key={index}
                      programColor="rgba(211, 47, 47, 0.25)"
                      enableHover={false}
                      sx={{ borderRadius: 1 }}
                    >
                      <Box sx={{ p: 2 }}>
                        <RewardText
                          title={reason.message}
                          titleColor="error.dark"
                        />
                      </Box>
                    </GradientRewardBox>
                  ))}
                </Box>
              </Box>
            )}
        </Box>
      </DialogContent>
    </Dialog>
  );
};
